import { useSession } from "@hooks/useSession";
import { queriesRequirements } from "@query";
import { WSPanel } from "@wingspanhq/fe-component-library";
import {
  RequirementDefinition,
  RequirementStatus
} from "@wingspanhq/wingspan-api-sdk";
import React from "react";

import { DataViewGrid } from "../../../../shared/components/DataView";

export const DefaultActionDetails: React.FC<{
  requirementDefinition: RequirementDefinition;
  engagementLength: number;
}> = ({ requirementDefinition, engagementLength }) => {
  const { accountId } = useSession();

  const queryPayeesRows = queriesRequirements.listPayeeRequirements.useQueryAll(
    {
      filter: {
        payerAccountId: { in: [accountId] },
        requirementDefinitionId: { in: [requirementDefinition.id!] }
      },
      page: {
        size: 1000
      }
    },
    { enabled: !!accountId }
  );

  const allRequirements = queryPayeesRows.flatData || [];

  const completedRequirementsLength = allRequirements.filter(
    req => req.status === RequirementStatus.COMPLETED
  ).length;

  return (
    <WSPanel shimmer={queryPayeesRows.isLoading}>
      <DataViewGrid
        data={[
          {
            label: "Requirement name",
            value: requirementDefinition.name
          },
          {
            label: "Engagements with this requirement",
            value: engagementLength
          },
          {
            label: "Contractor requirements assigned",
            value: allRequirements.length
          },
          {
            label: "Contractor requirements completed",
            value: completedRequirementsLength
          }
        ]}
        gridColumns={2}
      />
    </WSPanel>
  );
};
